import React from 'react';
import Styles from './cost-item-styles.scss';
const CostItem = ({ title, grade, cost, students, costPerStudent }) => {
    return (React.createElement("div", { className: Styles.costItem },
        React.createElement("div", { className: Styles.costItemHeader },
            React.createElement("div", { className: Styles.costItemHeaderLeft },
                `${title}`,
                " ",
                grade && React.createElement("span", { className: Styles.costItemHeaderLeftGrade }, `(${grade})`)),
            React.createElement("h4", { className: Styles.costItemHeaderRight }, `$${cost}`)),
        React.createElement("div", { className: Styles.costItemBody },
            React.createElement("h4", { className: Styles.costItemBodyLeft }, `${students}`),
            costPerStudent && React.createElement("h4", { className: Styles.costItemBodyRight }, `$${costPerStudent} per student`))));
};
export default CostItem;
